import { render, staticRenderFns } from "./DetailBox.vue?vue&type=template&id=743c021c&scoped=true&"
import script from "./DetailBox.vue?vue&type=script&lang=js&"
export * from "./DetailBox.vue?vue&type=script&lang=js&"
import style0 from "./DetailBox.vue?vue&type=style&index=0&id=743c021c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743c021c",
  null
  
)

export default component.exports